// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_nd-0";
export var buttonContainer = "_nd-3";
export var cancelButton = "_nd-4";
export var headerSection = "_nd-6";
export var headerTitle = "_nd-9";
export var messageSideLeft = "_nd-1";
export var messageSideRight = "_nd-2";
export var orderNumberContainer = "_nd-7";
export var orderNumberLabel = "_nd-8";
export var submitButton = "_nd-5";